require('dotenv').config();
/* eslint-disable max-len */

module.exports = {
  // default locale is the first one
  locales: [
    /* @intl-code-template '${lang}-${COUNTRY}', */
    'en-US',
    'es',
    'fr-FR',
    'ru-RU',
    'ja-JP',
    'id-ID',
    'hr-HR',
    'zh-CN',
    'sv-SE'
    /* @intl-code-template-end */
  ],

  // Node.js app
  port: process.env.PORT || 3000,

  // https://expressjs.com/en/guide/behind-proxies.html
  trustProxy: process.env.TRUST_PROXY || 'loopback',

  // SITE URL
  siteUrl: process.env.SITE_URL || 'https://www.guard-tec.com',

  // API Gateway
  api: {
    // API URL to be used in the client-side code
    clientUrl: process.env.API_CLIENT_URL || '',
    // API URL to be used in the server-side code
    serverUrl:
      process.env.API_SERVER_URL ||
      `http://localhost:${process.env.PORT || 3000}`,

    apiEndpoint: process.env.API_ENDPOINT_URL || 'https://www.guard-tec.com/api'
  },

  // Database
  //databaseUrl: process.env.DATABASE_URL,

  // Maximum upload size
  maxUploadSize: process.env.MAX_UPLOAD_SIZE || 20,

  // Licence Upload
  licenseuploadDir: process.env.LICENSE_UPLOAD_DIR || '/images/license/',

  // Vehicle Upload
  vehicleUploadDir: process.env.VEHICLE_UPLOAD_DIR || '/images/vehicle/',

  // Profile photo upload
  profilePhotouploadDir: process.env.PROFILE_PHOTO_UPLOAD_DIR || '/images/avatar/',

  // category photo upload
  categoryUploadDir: process.env.CATEGORY_PHOTO_UPLOAD_DIR || '/images/category/',

  // Logo photo upload
  logoUploadDir: process.env.LOGO_PHOTO_UPLOAD_DIR || '/images/logo/',

  // homepage photo upload
  homepageUploadDir: process.env.HOMEPAGE_UPLOAD_DIR || '/images/homepage/',

  // staticpage photo upload
  staticpageUploadDir: process.env.STATICPAGE_UPLOAD_DIR || '/images/staticpage/',

  //Content page photo upload
  contentPageUploadDir: process.env.CONTENTPAGE_UPLOAD_DIR || '/images/contentPage/',

  // Investigation Upload
  investigationUploadDir: process.env.INVESTIGATION_UPLOAD_DIR || '/images/investigations/',

  // Incident Upload
 incidentUploadDir: process.env.INCIDENT_UPLOAD_DIR || '/images/incidentReport/',

  // Document upload
  documentUploadDir: process.env.DOCUMENT_UPLOAD_DIR || '/images/documents/',

  // Push Notification Server Key
  serverKey: process.env.FCM_SERVER_KEY,

  //Google map api key
  googleMapAPI: process.env.GOOGLE_MAP_API || 'AIzaSyACqU_nY-g4Z5WMpnK3sFd0cwAYvuAyYl8',

  // Web analytics
  analytics: {
    // https://analytics.google.com/
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },

  // Payment - Stripe
  payment: { /* From ENV */
    stripe: {
      secretKey: process.env.STRIPE_SECRET,
    }
  },

  // Authentication
  auth: {
    //jwt: { secret: process.env.JWT_SECRET },

    // https://developers.facebook.com/
    facebook: {
      id: process.env.FACEBOOK_APP_ID,
      secret: process.env.FACEBOOK_APP_SECRET
    },

    // https://cloud.google.com/console/project
    google: {
      id: process.env.GOOGLE_CLIENT_ID,
      secret: process.env.GOOGLE_CLIENT_SECRET
    },

    // https://apps.twitter.com/
    twitter: {
      key: process.env.TWITTER_CONSUMER_KEY,
      secret: process.env.TWITTER_CONSUMER_SECRET
    }
  },
  
  disabledOfficerId: 5,
  
  officerOnlyTypeName: 'Officer Only',

  emailConfig: {
    host: process.env.SMTP_HOST, /* From ENV */
    port: process.env.SMTP_PORT || 2525,
    email: process.env.SMTP_LOGIN_EMAIL || 'info@guard-tec.com',
    sender: process.env.SMTP_FROM_NAME || 'Guard-tec',
    senderEmail: process.env.SMTP_SENDER_EMAIL || 'info@guard-tec.com',
    password: process.env.SMTP_LOGIN_PASSWORD,

  },

 placeDetailURL: "https://places.googleapis.com/v1/places/",
 autoCompleteURL: "https://places.googleapis.com/v1/places:autocomplete"

};

